import React from "react";
import { Col } from "antd";
import { ThemeFitToScreenCard } from "../../SurveysStyle";
import ConversationChat from "../../../../Components/ConversationChat";

const ChatPreview = () => {
  return <ConversationChat placeholder="Type Message" />;
};

export default ChatPreview;
